import React from 'react'

import { connect } from "react-redux"

// need to use withRouter higher order component to access the routing history since the Lobbyist actions isn't a route
// we could pass in as props from parent but this makes it stand alone
import { withRouter } from 'react-router'

import { Button } from 'primereact/button'
import { Toolbar } from 'primereact/toolbar'

import ConfirmDialog from '../components/common/ConfirmDialog'

import RejectReasonDialog from '../components/candidate/reject-reason-dialog'

import { createPdfForCandidates } from '../js/pdf'

import { STATUS_WITHDRAWN, STATUS_REJECTED, STATUS_REGISTERED, ROLE_ADMIN, ROLE_GOVERNMENT } from '../js/const'

import * as candidateActionCreators from "../actionCreators/candidate"
import * as appActionCreators from "../actionCreators/app"
import * as authActionCreators from "../actionCreators/auth"


class CandidateActions extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isShowingRehectReasondDialog: false,
      candidateIds: []
    }
  }

  goToHome = () => {
    this.props.history.push('/')
  }

  exportToPdf = (candidateId) => {
    this.props.setLoading(true)
      .then(() => this.setState(array => ({
        candidateIds: [...array.candidateIds, candidateId]
      })))
      .then(() => this.props.getCandidatesDetails(this.state.candidateIds))
      .then((response) => {
        let candidates = response.data ? response.data.$values : []
        createPdfForCandidates(candidates)
      })
      .then(() => this.props.setLoading(false))
      .catch((error) => this.props.handleError(error)
        .then(() => this.props.setLoading(false)))
  }

  showRejectReason = candidateId => {
    this.props.setLoading(true)
      .then(() => this.props.getRejectReasonCandidate(candidateId))
      .then(() => {
        this.setState({ isShowingRehectReasondDialog: true })
      })
      .then(() => this.props.setLoading(false))
      .catch((error) => this.props.handleError(error)
        .then(() => this.props.setLoading(false)))
  }

  closeRejectReason = () => this.setState({ isShowingRehectReasondDialog: false })

  rejectReasonFormSubmitted = rejectReason => {
    this.props.setLoading(true)
      .then(() => {
        this.props.rejectCandidate(rejectReason)
          .then(response => {
            this.props.setAjaxResponse(response)
            this.props.setLoading(false)
          })
      })
      .catch((error) => this.props.handleError(error)
        .then(() => this.props.setLoading(false)))
  }

  withdraw = candidateId => {
    this.props.setLoading(true)
      .then(() => {
        this.props.withdrawCandidate(candidateId)
          .then(response => {
            // set response in store so global response component can handle response
            this.props.setAjaxResponse(response)
            if (response.data.Success) {
              // lobbyist has successfully withdrawn so logout
              if (response.data.Login)
              {
                this.props.performLogout()
                .then(() => {
                  this.props.history.push('/')
                  this.props.setLoading(false)
                })
                .catch((error) => this.props.handleError(error)
                  .then(() => this.props.setLoading(false)))
              }
              else
              {
                this.props.setLoading(false)
              }
            } else {
              this.props.setLoading(false)
            }
          })
      })
      .catch((error) => this.props.handleError(error)
        .then(() => this.props.setLoading(false)))
  }

  delete = candidateId => {
    this.props.setLoading(true)
      .then(() => {
        this.props.deleteCandidate(candidateId)
          .then(response => {
            // set response in store so global response component can handle response
            this.props.setAjaxResponse(response)
            if (response.data.Success) {
                this.props.history.push('/')
                this.props.setLoading(false)
            } else {
              this.props.setLoading(false)
            }
          })
      })
      .catch((error) => this.props.handleError(error)
        .then(() => this.props.setLoading(false)))
  }

  reactivate = candidateId => {
    this.props.setLoading(true)
      .then(() => {
        this.props.reactivateCandidate(candidateId)
          .then(response => {
            this.props.setAjaxResponse(response)
            this.props.setLoading(false)
          })
      })
      .catch((error) => this.props.handleError(error)
        .then(() => this.props.setLoading(false)))
  }

  render() {
    // check if current lobbyist that is being looked at exists. If not create an empty object to deal with issues that could be caused by lobbyist being undefined
    let currentCandidate = this.props.candidate.currentCandidate ? this.props.candidate.currentCandidate : {}
    let rejectReason = this.props.candidate.rejectReason ? this.props.candidate.rejectReason : {}

    let isAuthenticated = this.props.auth.isAuthenticated
    let isAdd = !currentCandidate.CandidateId
    let isAdmin = this.props.auth.roles && this.props.auth.roles.some(role => role === ROLE_ADMIN)
    let isGovernment = this.props.auth.roles && this.props.auth.roles.some(role => role === ROLE_GOVERNMENT)

    let isRegistered = currentCandidate.StatusCode === STATUS_REGISTERED
    let isRejected = currentCandidate.StatusCode === STATUS_REJECTED
    let isWithdrawn = currentCandidate.StatusCode === STATUS_WITHDRAWN

    let isCorrectCandidate = currentCandidate.CandidateId === this.props.auth.candidateId


    let canSave = (isAdd === false && isAuthenticated === true && (isAdmin === true || isCorrectCandidate)) || isAdd
    let canSaveWithoutNotification = isAdd === false && isAuthenticated === true && (isAdmin === true || isGovernment === true)
    let canReject = isAdd === false && isAuthenticated === true && isAdmin === true && isRegistered
    let canWithdraw = isAdd === false && isAuthenticated === true && isGovernment === false && (isCorrectCandidate || isAdmin) && !isWithdrawn
    let canReactivate = isAdd === false && isAdmin && (isRejected || isWithdrawn)
    let canDelete = isAdd === false && isAdmin

    let saveLabel = isAdd ? "Register" : "Save"
    let backLabel = isAdd ? "Cancel Registration" : "Go to List of Candidates"
    let hideExportToPDF = isAdd ? true : false
    return (
      <React.Fragment>
        <Toolbar id="confirmChanges">
          <div className="p-toolbar-group-left">
            {canSave && <Button label={saveLabel} icon="pi pi-check" className="p-button-primary"
              onClick={() => {
                this.props.setIsSavingWithoutNotification(false)
                this.props.formApi.submitForm()
              }} style={{ margin: 10, minWidth: '150px' }} />}
            {canSaveWithoutNotification && <Button label={"Save as Authorised User"} icon="pi pi-check" className="p-button-primary"
              onClick={() => {
                this.props.setIsSavingWithoutNotification(true)
                this.props.formApi.submitForm()
              }} style={{ margin: 10, minWidth: '150px' }} />}
            {canReactivate && <ConfirmDialog buttonLabel="Reactivate" buttonIcon="pi pi-check" buttonIconPos="left" buttonClassName="p-button-success" handleOnYesClick={() => this.reactivate(currentCandidate.CandidateId)}
              title={'Confirm Candidate Reactivation'} message={'Do you want to reactivate this candidate?'}
            />}
            {(isAdmin || isGovernment || isAdd) && <Button label={backLabel} className="p-button-secondary" onClick={this.goToHome} style={{ margin: 10 }} />}
            {(isAdmin || isGovernment || isCorrectCandidate) && !hideExportToPDF && <Button id="exportToPDFInDetails" label={"View as PDF"} className="p-button-secondary" onClick={() => this.exportToPdf(currentCandidate.UniqueId)} style={{ margin: 10 }} />}
          </div>
          <div className="p-toolbar-group-right">
            {canReject && <ConfirmDialog buttonLabel="Reject" buttonIcon="pi pi-times" buttonIconPos="left" buttonClassName="p-button-danger" handleOnYesClick={() => this.showRejectReason(currentCandidate.CandidateId)}
              title={'Confirm Candidate Rejection'} message={'Do you want to reject this candidate?'}
            />}
            {canWithdraw && <ConfirmDialog buttonLabel="Withdraw" buttonIcon="pi pi-times" buttonIconPos="left" buttonClassName="p-button-danger" handleOnYesClick={() => this.withdraw(currentCandidate.CandidateId)}
              title={'Confirm Candidate Withdrawal'} message={'Do you want to withdraw from the register?'}
            />}
            {canDelete && <ConfirmDialog buttonLabel="Delete" buttonIcon="pi pi-times" buttonIconPos="left" buttonClassName="p-button-danger" handleOnYesClick={() => this.delete(currentCandidate.CandidateId)}
              title={'Confirm Candidate Deletion'} message={'Do you want to delete candidate from the register? This action cannot be reversed.'}
            />}
          </div>
        </Toolbar>
        {canReject && <RejectReasonDialog isShowingRehectReasondDialog={this.state.isShowingRehectReasondDialog} rejectReason={rejectReason}
          rejectReasonFormSubmitted={this.rejectReasonFormSubmitted} closeRejectReason={this.closeRejectReason}></RejectReasonDialog>}
      </React.Fragment>
    )
  }
}

const mapStateToProps = ({ candidate, auth }) => {
  return { candidate, auth }
}

// this is how to combine actions available
const actionCreators = {
  ...candidateActionCreators,
  ...appActionCreators,
  ...authActionCreators
}

export default withRouter(connect(mapStateToProps, actionCreators)(CandidateActions))


// WEBPACK FOOTER //
// ./src/container/CandidateActions.js